import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import { AssetManager } from 'components/sharpr/assetManager/AssetManager';

export function SettingsSsoLinksRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.SettingsSsoLinks', {
		url: '/admin/sso_urls',
		controllerAs: 'vm',
		controller: SettingsSsoLinksCtrl,
		templateUrl: '/ng/hub/Settings/Sso/Links/SettingsSsoLinksCtrl.html?' + window.BUILD,
		resolve: {
			$title: () => 'SettingsSsoLinks page',
			style: () => AssetManager.css('/ng/hub/Settings/Sso/Links/SettingsSsoLinksCtrl.css'),
			links: ApiResourcify.endpoint('/sso/links'),
		},
	});
}

export class SettingsSsoLinksCtrl {
	constructor(links, Identity) {
		'ngInject';
		this.links = links;
		this.Identity = Identity;
		this.availableHubs = this.Identity.hubChoices();
		this.nonSsoUrl = `${window.BASE_URL}/login`;
	}

	$onInit() {
		this.links.forEach(link => {
			link.showCog = new URL(link.url).pathname === '/login';
		});
	}

	getDirectLink() {
		// Opens the modal
		this.previewDirectHubLink = true;
		if (!this.backTo || !this.selectedHub || this.selectedLink === null) {
			return;
		}
		const ssoUrl = new URL(this.selectedLink.url);
		const spCode = ssoUrl.searchParams.get('sso');
		let url = `${ssoUrl.origin}/hub?sso=${spCode}&forwardTo=`;
		// Step 1. Create a new URL obj for the backTo input
		let backToUrlObj = new URL(this.backTo);
		// Step 2. Strip domain off the provided back to url
		let backTo = backToUrlObj.pathname + backToUrlObj.hash;
		// Step 3. Encode the back to URL. (It will be double encoded in the end)
		let backToUrlEncoded = this.safeEncode(backTo);
		// Step 4. Encode the forward to section and double encode backTo
		let forwardTo = `${ssoUrl.origin}/users/setclient/${this.selectedHub.id}?backTo=${backToUrlEncoded}`;
		let forwardToUrlEncoded = this.safeEncode(forwardTo);
		return url.concat(forwardToUrlEncoded);
	}

	safeEncode(url) {
		const safeEncodedUrl = encodeURIComponent(url).replace(/[!'()*]/g, c => {
			return '%' + c.charCodeAt(0).toString(16);
		});
		return safeEncodedUrl;
	}

	copyToClipboard() {
		document.getElementById('DirectLink').select();
		document.execCommand('copy');
	}

	clear() {
		this.selectedLink = null;
		this.backTo = null;
		this.selectedHub = null;
	}
}
